import * as React from 'react';

import { cn } from '../../lib/utils';

const TypographyH3 = React.forwardRef<
  HTMLHeadingElement,
  React.HTMLAttributes<HTMLHeadingElement>
>(({ className, ...props }, ref) => (
  // eslint-disable-next-line jsx-a11y/heading-has-content
  <h3
    ref={ref}
    className={cn('scroll-m-20 text-display-lg font-regular', className)}
    {...props}
  />
));
TypographyH3.displayName = 'TypographyH3';

export { TypographyH3 };
